import { httpDelete, httpGet, httpPost, httpPut } from '../../../global/http-utils';
import { returnResponseIfOkOrSetGlobalErrorMessage } from '../../../global/api-utils';

export const getTerminologyData = ({ tenantId, sourceLocale, targetLocale, pageSize = 50, lastKey }) => {
  const params = {
    pageSize,
    ...(lastKey && { lastKey }),
    ...(sourceLocale && { sourceLocale }),
    ...(targetLocale && { targetLocale }),
  };
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/${tenantId}/terminology-data`, undefined, params),
    'Failed to retrieve terminology data'
  );
};

export const addTerminologyEntry = ({ tenantId, entry }) =>
  returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpPost(`tsi-multit/tenants/${tenantId}/terminology-data`, { entry }),
    'Failed to add terminology entry'
  );

export const updateTerminologyEntry = ({ tenantId, entry }) =>
  returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpPut(`tsi-multit/tenants/${tenantId}/terminology-data`, { entry }),
    'Failed to update terminology entry'
  );

export const removeTerminologyEntry = ({ tenantId, entry }) =>
  returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/tenants/${tenantId}/terminology-data`, { entry }),
    'Failed to delete terminology entry'
  );

export const batchUploadTerminology = ({ tenantId, file }) => {
  const formData = new FormData();
  formData.append('file', file);
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpPost(`tsi-multit/tenants/${tenantId}/terminology-data/batch-upload`, formData),
    'Failed to upload terminology CSV'
  );
};

export const exportTerminology = ({ tenantId }) =>
  returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/${tenantId}/terminology-data/export`),
    'Failed to export terminology CSV'
  );
